ACC.product = {

	initQuickviewLightbox:function(){
		this.bindToAddToCartForm();
	},


	bindToAddToCartForm: function ()
	{
		var addToCartForm = $('.add_to_cart_form');
		addToCartForm.ajaxForm({
		    beforeSubmit: function (arr,formElement, options) {
		      $('.js-add-to-cart').addClass('disabled');
		    },
			success: function (cartResult, statusText, xhr, formElement) {
                if (typeof resetQuantity !== "undefined") {
                    resetQuantity();
                }
				ACC.product.updatePDPStockLevel(cartResult);
				ACC.product.displayAddToCartPopup(cartResult, statusText, xhr, formElement);
                if (localStorage.getItem('calculationId') || $('.file-upload-component')[0]) {
                    ACC.product.cleanLaserCuttingPdp();
                }
                // enable the js-add-to-cart buttons
                $('.js-add-to-cart').removeClass('disabled');
			},
			error: ACC.product.ajaxErrorHandler
		});
	},

	userSessionAvailability: function(url)
	{
		var userInactive = false;
		if(url){
			$.ajax({
				async: false,
				type: "GET",
				url: url,
				success: function(data) {
					if(data){
						userInactive = true;
					}
				},
			});
		}
		return userInactive;
	},

    ajaxErrorHandler: function (data, url) {

		var userAvailable = ACC.product.userSessionAvailability(url);
		if(userAvailable) {
			window.location.reload();
			return false;
		}

		// enable the js-add-to-cart buttons
		$('.js-add-to-cart').removeClass('disabled');

        // reset variant selection
        ACC.productDetail.deleteChosenDimensions();

        $.colorbox({
            innerWidth: '500px',
            html: data.responseText,
            scrolling: false,
            onComplete: function () {
                $('.js-close-button').on('click', function (e) {
                    e.preventDefault();
                    $.colorbox.close();
                });

                // do it second time because of noCustomVariantOnClick quantity change timeout call
                // reset variant selection
                ACC.productDetail.deleteChosenDimensions();
            },
            onClosed: function () {
                // do it second time because of noCustomVariantOnClick quantity change timeout call
                // reset variant selection
                ACC.productDetail.deleteChosenDimensions();
                ACC.productDetail.deselectChosenDimensions();
            }
        });
    },

    cleanLaserCuttingPdp: function () {
        localStorage.removeItem('calculationId');
        localStorage.removeItem('laserCuttingFileUniqueId');
        localStorage.removeItem('realFileName');
        $('.js-dim-label').removeClass('selected');
        $('.js-dim-label').removeClass('disabled');
        $('.js-dim-label').addClass('orderable');
        $('.js-dim-label').attr('data-state','orderable');
        sessionStorage.removeItem('selectedValues');
        ACC.laserCuttingFileUploadComponent.checkForFileThenRender();
    },

	displayAddToCartPopup: function (cartResult, statusText, xhr, formElement) {
		$("#globalMessages").html(htmlDecode(cartResult.cartGlobalMessagesHtml));

		$('.js-add-to-cart-layer').remove();

        if (typeof cartResult.cartData.totalItems !== "undefined") {
            if (typeof ACC.minicart.refreshMiniCartCount == 'function') {
                ACC.minicart.refreshMiniCartCount(cartResult.cartData.cartType, cartResult.cartData.totalItems);
            }
        }

		$(".js-header .js-container").append(htmlDecode(cartResult.addToCartLayer));


		$('.js-add-to-cart-layer').fadeIn(function(){
			$.colorbox.close();
			if (typeof timeoutId != 'undefined') {
				clearTimeout(timeoutId);
			}
			timeoutId = setTimeout(function () {
				$('.js-add-to-cart-layer').fadeOut(function(){
					$(this).remove();
				});
			}, 5000);
		});

		var productCode = $('[name=productCodePost]', formElement).val(),
			quantityField = $('[name=qty]', formElement).val(),
			quantity = 1;

		if (quantityField != undefined) {
			quantity = quantityField;
		}

        ACC.cart.currentKloecknerMerchantCartId = cartResult.currentKloecknerMerchantCartId;
        ACC.common.setupActiveCartForSpartacus();
		ACC.track.trackAddToCart(productCode, quantity, cartResult.cartData);

		// if it is orderForm, disable add to cart button in the end
		if($('#orderFormAddToCart').length > 0) {
			$('#addToCartBtn').attr('disabled','disabled');
		}
	},

	updatePDPStockLevel: function (data) {
		if (data.modifications != null) {

			var productList = $(data.modifications.products);
			var productCode = $('#displayVariantCode').html();

			$.each(productList, function(i, item) {
				if (item.displayCode == productCode && item.stockLevel!="") {
					$('.js-sale-product-available .count').html(item.stockLevel)
				}
			});
		}
	},
    hidePerfectMatch: function () {
        var perfectMatchNode = $(".js-perfect-match");
        var variantDiv = $("#productVariants");
        variantDiv.removeClass("hide");
        perfectMatchNode.addClass("hide");
        $(".productImageGallery").removeClass("hide");
    }
};

$(document).ready(function ()
{
	with(ACC.product)
	{
		bindToAddToCartForm();
	}
});

